var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-overlay"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-balls"},[_c('div',{staticClass:"ball"}),_c('div',{staticClass:"ball"}),_c('div',{staticClass:"ball"})])
}]

export { render, staticRenderFns }